import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent {

  // file = "../../assets/image/module page.jpg";
  // fileDownload=ApiUrls.fileDownload;
  // downloadPdf=ApiUrls.downloadPdf;
  constructor(private router: Router){ }
  contact() {
    this.router.navigate(['contact']);
  }

  // isImg: any;
  //   isPdf: any;
  //   unsuppFile: any;
  //   selectedFile = null;
  
  //   showFile(showFile) {
  //     this.selectedFile = null;
  //     console.log('called: ', showFile);
  //     const file_value = showFile.fileName.split('.');
  //     const fileType = file_value[file_value.length - 1];
  //     if (fileType === 'jpg' || fileType === 'jpeg' || fileType === 'png' || fileType === 'PNG' || fileType == 'image/jpeg' || fileType == 'image/png') {
  //       this.isPdf = null;
  //       this.isImg = fileUpload + "?fileUuid=" + showFile.fileUUID;
  //       this.selectedFile = showFile;
  //     } else {
  //       if (fileType === 'pdf' || fileType == 'application/pdf') {
  //         this.isImg = null;
  //         this.isPdf = this.genS.fileUpload + "?fileUuid=" + showFile.fileUUID;
  //         console.log(this.isPdf);
  
  //         this.selectedFile = showFile;
  //       }
  //       else {
  //         this.unsuppFile = "File type is not currently supported. Please download the file from above link";
  //       }
  
  //     }
  
  //   }
}
